import React from "react";
import { Link } from "gatsby"
import style from "./insurance.module.scss";

function Insurance() {

  return (
    <div className={style.insurance} id="insurance">
      <div className="container">
        <h3 className={style.insurance__title}>PRICING & INSURANCE</h3>
        <div className={style.insurance__content}>
          <h2 className={style.insurance__contentTitle}>Insurance Coverage</h2>
          <div className={style.insurance__contentText}>
            <p>AcuBoston, Inc. accepts insurance. To check if your insurance benefits include acupuncture,
                please <Link to="/#contacts">Contact Us</Link>.</p>
            <p>Please include the following to have your insurance verified: Name of Insurance,
                Your Insurance ID number, your date of birth, your address, your email, your phone number.</p>
            <br/>
            <p>We will contact you as soon as the benefits are established. Verification of benefits takes 48 hours.
              Please submit your information in a timely fashion. If you do not have coverage for acupuncture, or if we
              have been unable to verify your benefits before your appointment, please see service fees for patients
              paying out of pocket, listed below.</p>
          </div>
        </div>
      </div>
      <div className={style.insuranceBg}>
      </div>
    </div>
  )
}

export default Insurance